module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "1.00em"
    }
  }, [_vm._v("Don’t miss Modern Knights with book 2, ")]), _c('span', {
    staticStyle: {
      "font-size": "1.00em"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://smarturl.it/TwoCO",
      "target": "_blank"
    }
  }, [_vm._v("TWO WIZARD ROULETTE")])]), _c('span', {
    staticStyle: {
      "font-size": "1.00em"
    }
  }, [_vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "1.00em"
    }
  }, [_vm._v("Being a personal wizard to a multinational CEO isn't all fun and games. When Colin's not busy with assassins and his own inner demons, there's amnesia potions and odd jobs like hunting down a serial criminal or two.")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing__OPENPAR_2_CLOSEPAR_"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "1.00em"
    }
  }, [_vm._v("If the billionaire boss was bad, the relationship between Colin and his demon-blooded girlfriend Veruca has been downright turbulent since last winter's freak blizzard. It doesn't make the situation any easier that his favorite FBI contact looks exactly like his missing, presumed dead, fiancé.")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing__OPENPAR_2_CLOSEPAR_"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "1.00em"
    }
  }, [_vm._v("All of that would be enough to keep Colin busy. But when a dangerous gambler with magical powers of his own, and his demoness consort, start fleecing Vegas casinos for millions, Colin finds himself trapped in a high stakes game of two wizard roulette.")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing__OPENPAR_2_CLOSEPAR_"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "1.00em"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://smarturl.it/TwoCO",
      "target": "_blank"
    }
  }, [_vm._v("BUY NOW")])]), _c('span', {
    staticStyle: {
      "font-size": "1.00em"
    }
  }, [_vm._v("!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 75
// module chunks = 0